import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import QRCode from 'react-qr-code';
import './Menu.scss';
import './callout.scss';
import SubmenuList from './SubmenuList';
import AccordionContent from './AccordionContent';
import Arbutton from './Arbutton'; // Added AR button import
import Badges from '../Badges/Badge'; // Adjust path if needed

const Menu = (props) => {
  const { handleHotspotClick = () => console.warn("handleHotspotClick not provided") } = props;
  const { popupButtonClicks = () => console.warn("popupButtonClicks not provided") } = props;

  let menuList = [...props.menuSubmenu];
  let productTypeMenu = [];
  let QRSupport = props.QRSupport;
  let { QR, ReduceTransitions } = { ...props.ui };
  let onLoadActiveAccordionMobile = props.onLoadActiveAccordionMobile;

  const [activeBadgesInfo, setActiveBadgesInfo] = useState(null);
  // const [activeAccordionId, setActiveAccordionId] = useState(null);
// console.log("popupButtonClicks prop:", props.popupButtonClicks);

  const [activeAccordionId, setActiveAccordionId] = useState(() => {
  if (window.isMobIsipadIsPotrait) {
    const defaultId = props.onLoadActiveAccordionMobile;
    const defaultItem = props.menuSubmenu?.find((item) => item.id === defaultId);
    return defaultItem?.id || props.menuSubmenu?.[0]?.id || null;
  }
  return null;
});

  let filterMenuBasedOnConfigType = props.filterMenuBasedOnConfigType;

  let cssVariableValues = props.cssVariableValues;
  let accordionMenuTextWidth =
    parseInt(cssVariableValues.menuWidth) -
    (parseInt(cssVariableValues.accordionMenuPaddingLeft) +
      parseInt(cssVariableValues.accordionMenuPaddingRight) +
      parseInt(cssVariableValues.accordionMenuIconWidth) +
      parseInt(cssVariableValues.accordionMenuIconMarginLeft) +
      parseInt(cssVariableValues.accordionMenuIconMarginRight) +
      parseInt(cssVariableValues.accordionMenuChevronWidth) +
      parseInt(cssVariableValues.accordionMenuChevronMarginLeft));
  let qrTextWidth = parseInt(cssVariableValues.menuWidth) - parseInt(cssVariableValues.menuFooterPaddingLeftRight) * 2;

  let qrTextContentwidth = props.calcHtmlElementNoWrapWidth(QR, cssVariableValues.qrTextFontSize);
  let adjuestedWidth = window.UiUtils.checkIfWidthNeedUpdate(qrTextContentwidth, qrTextWidth, cssVariableValues.qrTextFontSize);

  const toggleBadgeVisibility = (item) => {
    if (item?.badgesInfo?.badge) {
      setTimeout(() => {
      setActiveBadgesInfo(item.badgesInfo);        
      }, 1000);
    } else {
      setActiveBadgesInfo(null);
    }
  };

  useEffect(() => {
    window.toggleBadgeVisibility = toggleBadgeVisibility;
  }, []);

  const handleSubMenuClickEnhanced = (item, e) => {
    props.handleSubMenuClick(item, e);
      toggleBadgeVisibility(item);
  };

  const handleMainMenuClick = (item) => {
    setActiveAccordionId(item.id);
    props.accordionMenuclick(item, "accordion_" + item.id);
    toggleBadgeVisibility(item);
        if (window.shouldReRenderMenu) window.reRenderMenu();   // 👈 ye line add karo

  };

  if (window.isMobIsipadIsPotrait) {
    menuList = menuList.filter((list) => list.id !== "ProductType");
    productTypeMenu = props.menuSubmenu.filter((list) => list.id === "ProductType");
  }
  if (productTypeMenu.length === 1) productTypeMenu = productTypeMenu[0];

  // QR code and URL setup
  if (window.location.href) {
    let url = window.location.href.split('?')[0];
    if (!url.endsWith('index.html')) {
      if (!url.endsWith('/')) url += '/';
      url += 'index.html';
    }
    let params = window.location.href.split('?')[1];
    let newParames = '?qr=1';
    if (params !== undefined && !params.includes('qr=')) newParames = newParames + '&' + params;
    else if (params !== undefined && params.includes('qr=')) newParames = '?' + params;
    url = url + newParames;

    if (params !== undefined && params.includes('contentURL=')) {
      let contentURL = params.split('contentURL=')[1];
      url = contentURL + '?qr=1';
    }

    window.linkForGenerateQR = `${url}`;
  }

  let filteredMenuList = menuList.filter(filterMenuBasedOnConfigType);
  let accordionUpdated = false;
  if (window.selectedConfig['menuList'] && window.selectedConfig['menuList'].length != undefined && window.selectedConfig['menuList'].length !== filteredMenuList.length)
    accordionUpdated = true;

  window.selectedConfig['menuList'] = [...filteredMenuList];
  window.config.nextPrevArray = [];

  filteredMenuList.forEach((list) => {
    if (window.config.nextPrevArray.findIndex((e) => e && e.id === list.id) === -1) window.config.nextPrevArray.push(list);

    if (list.items && list.items.length) {
      list.items.forEach((item) => {
        if (window.config.nextPrevArray.findIndex((e) => e && e.id === item.id) === -1) {
          window.config.nextPrevArray.push(item);
          // Add dimensions to nextPrevArray if present
          if (item.hotspotDataInfo && Array.isArray(item.hotspotDataInfo) && item.hotspotDataInfo.length > 0 && window.config.dimensions) {
            item.hotspotDataInfo.forEach((dim) => {
              window.config.nextPrevArray.push({ ...dim, type: 'dimension', id: dim.htmlid || dim.hsname, parentSubmenuId: item.id });
            });
          }
  if (item.popupBoxButtons && Array.isArray(item.popupBoxButtons)) {
  item.popupBoxButtons.forEach((btnGroup) => {
    if (!btnGroup) return;

    Object.values(btnGroup).forEach((btn) => {
      if (!btn) return;

      window.config.nextPrevArray.push({
        ...btn,
        type: 'popupBoxButton',
        id: btn.id || btn.sequenceName, // 🔥 hotspot jaisa id guarantee
        parentSubmenuId: item.id
      });
    });
  });
}



        }
      });
          // console.log("next", window.config.nextPrevArray);
    }
  });

  window.menuSubmenuTabindex = 6;
  let menuIndex = window.menuSubmenuTabindex;

  return (
    <>
                    {window.isMobIsipadIsPotrait && <div id="colorContainerMobile"></div>}

      <nav id="mainMenu" className="menuContainer expanded">
        {/* Product type button for mobile */}

        {productTypeMenu.length === undefined && window.isMobIsipadIsPotrait && (
          <div className="productTypeBtn">
            <img className="icon" src={productTypeMenu.iconMobile} />
            <span className="productTypeMenuTitle">{productTypeMenu.mobileTitle}</span>
            <ul className="productTypeList">
              {productTypeMenu.items.map((item) => {
                let isActive = window.selectedConfig[item.featureType] === item.id;
                return (
                  <li
                    key={item.id}
                    className="subMenuBtn radioButton mob"
                    id={`menu_id_${item.id}`}
                    onClick={(e) => {
                      props.handleSubMenuClick(item, e);
                      toggleBadgeVisibility(item);
                    }}
                  >
                    <label>
                      <input type="radio" name={item.radioName} value={item.id} defaultChecked={isActive} />
                    </label>
                    <span className="mobRadioTitle"> {item.mobileTitle} </span>
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <ul>
          {filteredMenuList.map((list, listIndex) => {
            const isLastItem = listIndex === filteredMenuList.length - 1;
            const isArpopup = list.id === "arpopup";
            // console.log("isArpopup:", isArpopup, "isLastItem:", isLastItem, "window.isMobIsipadIsPotrait:", window.isMobIsipadIsPotrait);

            // Mobile AR fix: show only button in mobile portrait
            if (isArpopup && window.isMobIsipadIsPotrait) {
  return (
    <li key="mobile-ar-btn" className="accordionMenu arButtonMobile" tabIndex={0}>
      <Arbutton ui={props.ui} calcHtmlElementNoWrapWidth={props.calcHtmlElementNoWrapWidth} />
    </li>
  );
}
let isFirstAccordion = props.isFirstAccordion;
const defaultMobileAccordionId = props.onLoadActiveAccordionMobile; // "Exterior"
let isAccordionActive =
  (isFirstAccordion && window.isMobIsipadIsPotrait && list.id === defaultMobileAccordionId) ||
  (!isFirstAccordion && window.isMobIsipadIsPotrait && list.id === defaultMobileAccordionId && window.selectedConfig.selectedAccordion === undefined) ||
  (!isFirstAccordion && window.selectedConfig.selectedAccordion !== undefined && window.selectedConfig.selectedAccordion.includes("accordion_" + list.id) || window.selectedConfig.currentSelectedAccordion === "accordion_" + list.id);
               

            return (
              <React.Fragment key={list.id}>
                <li
                  id={"accordion_" + list.id}
                  role="button"
                  className={isAccordionActive ? "accordionMenu active" : "accordionMenu"}
                  onClick={() => handleMainMenuClick(list)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleMainMenuClick(list);
                  }}
                  tabIndex={0}
                >
                  {/* <img className="icon" src={window.isMobIsipadIsPotrait ? list.mobIcon : list.icon} /> */}
                  <span className="icon-circle"></span>
                  <span
                    className="text"
                    data-width={accordionMenuTextWidth}
                    data-contentwidth={props.calcHtmlElementNoWrapWidth(list.title, cssVariableValues.accordionMenuTextFontSize)}
                  >
                    {!window.isMobIsipadIsPotrait ? list.title : list.mobileTitle}
                  </span>
                  <svg viewBox="0 0 32 32" className="chevron" aria-hidden="true" focusable="false">
                    <path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path>
                  </svg>
                </li>

                {list.items && (
                  <>
                    <SubmenuList
                      count={props.count}
                      accordionId={"accordion_" + list.id}
                      parentIndex={menuIndex}
                      activeAccordionId={activeAccordionId}
                      accordionData={list}
                      subMenuList={list.items}
                      handleSubMenuClick={handleSubMenuClickEnhanced}
                      handleHotspotClick={handleHotspotClick}
                      popupButtonClicks={popupButtonClicks}
                      filterMenuBasedOnConfigType={filterMenuBasedOnConfigType}
                      calcHtmlElementNoWrapWidth={props.calcHtmlElementNoWrapWidth}
                      cssVariableValues={cssVariableValues}
                      QR={QR}
                      ui={props.ui}
                    />
                    <AccordionContent
                      accordionContentList={list.items}
                      accordionData={list}
                      filterMenuBasedOnConfigType={filterMenuBasedOnConfigType}
                      activeAccordionId={activeAccordionId}
                      accordionId={"accordion_" + list.id}
                      cssVariableValues={cssVariableValues}
                      calcHtmlElementNoWrapWidth={props.calcHtmlElementNoWrapWidth}
                    />
                  </>
                )}
              </React.Fragment>
            );
          })}
        </ul>

        {/* Badges */}
        {/* {(!window.isMobIsipadIsPotrait) && ( */}
          <Badges badgesInfo={activeBadgesInfo} />
        {/* )} */}
      </nav>
    </>
  );
};

export default Menu;
